import { LinkOrSkeletonProps } from "../../interfaces";

export const getFooterLinks = (
  isLoaded: boolean,
  currentYear: number,
  currentLang: string,
  t: (key: string) => string
): LinkOrSkeletonProps[] => [
  {
    isLoaded,
    href: "https://id.express",
    text: `© ${currentYear} ID.Express`,
    width: "150px",
  },
  {
    isLoaded,
    href: `/${currentLang}/terms_and_conditions/`,
    text: t("Terms and Conditions"),
    width: "175px",
  },
  {
    isLoaded,
    href: `/${currentLang}/privacy_policy/`,
    text: t("Privacy Policy"),
    width: "120px",
  },
  {
    isLoaded,
    href: `/${currentLang}/cookies/`,
    text: t("Cookies"),
    width: "75px",
  },
];
